import {
  Injector,
  isDevMode,
  APP_INITIALIZER,
  NgModule,
  ErrorHandler,
  enableProdMode,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  inject,
} from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AbstractControl, FormsModule, ReactiveFormsModule, ValidationErrors } from '@angular/forms';

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { IonicStorageModule } from "@ionic/storage-angular";

import {
  ConnectionServiceModule,
  ConnectionServiceOptions,
  ConnectionServiceOptionsToken,
  GeolocationModule,
  NgxUtilCoreModule,
} from '@hssa-itasia/ngx-util-core';


import { LoggerModule, NgxLoggerLevel } from "ngx-logger";

import { FormlyModule, FORMLY_CONFIG } from "@ngx-formly/core";
import { FormlyMaterialModule } from "@ngx-formly/material";
import { FormlyMatDatepickerModule } from "@ngx-formly/material/datepicker";
import { FormlyMatToggleModule } from "@ngx-formly/material/toggle";

import { TextareaWithCounterComponent } from "./components/textarea-with-counter-formly.component";

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatListModule } from '@angular/material/list';
import { RoundProgressModule, ROUND_PROGRESS_DEFAULTS } from 'angular-svg-round-progressbar';
import { NgApexchartsModule } from 'ng-apexcharts';
import { provideFirebaseApp, initializeApp, getApp, FirebaseApp } from '@angular/fire/app';
import {
  browserLocalPersistence,
  getAuth,
  indexedDBLocalPersistence,
  initializeAuth,
  provideAuth,
} from '@angular/fire/auth';
import {
  getAnalytics,
  provideAnalytics,
  ScreenTrackingService,
  UserTrackingService,
} from '@angular/fire/analytics';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getRemoteConfig, provideRemoteConfig } from '@angular/fire/remote-config';
import { getStorage, provideStorage } from '@angular/fire/storage';
import {
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  provideFirestore,
} from '@angular/fire/firestore';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Router } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { IonicGestureConfig } from 'src/app/gestures/ionic-gesture-config';
import { GRUEditComponent } from 'src/app/components/workgroup_management/gru-edit/gru-edit.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule, DatePipe } from '@angular/common';
import { Capacitor } from '@capacitor/core';
import { NgxImageCompressService } from 'ngx-image-compress';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MentionModule } from 'angular-mentions';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { BackgroundMode } from '@ionic-native/background-mode/ngx';
import { DecimalPipe } from '@angular/common';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { MatSliderModule } from '@angular/material/slider';
import { getDatabase, provideDatabase } from '@angular/fire/database';
import { AutocompleteFormlyComponent } from './components/auto-complete-formly.component';

import { MultiCheckboxFormlyType } from './components/multicheckbox-formly.component';
import { CheckboxRepeat } from './components/checkbox-repeat-formly-component';
import { CustomAccordianFormlyType } from './components/custom-accordian-formly.component';
import { CustomToggleFormlyType } from './components/custom-toggle-formly.component';
import { RadioButtonFormlyType } from './components/radiobutton-formly-component';
import { CustomRadioButtonFormlyType } from './components/custom-radiobutton-formly-component';

import { environment, FIREBASE_CONFIG } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppInjectorService } from './services/app-injector/app-injector.service';
import { SearchService } from './providers/search-service/search-service';
import { registerTranslateExtension } from './services/translate.extension';
// import * as Sentry from "@sentry/angular";
import { BonusRadioButtonFormlyType } from './components/bonus-radiobutton-formly-component';
import { TreasureHuntChangeDateComponent } from './components/treasure-hunt-change-date/treasure-hunt-change-date.component';
import { TreasureHuntInfoComponent } from './components/treasure-hunt-info/treasure-hunt-info.component';
//import { GoogleMapsComponent } from './components/google-maps/google-maps.component';
import { ReassignActionComponent } from "./components/reassign-action/reassign-action.component";
import { FilterActionStatusComponent } from "./components/filter-action-status/filter-action-status.component";

import { AddOrRemoveZonesComponent } from './components/add-or-remove-zones/add-or-remove-zones.component';
import { DashboardCheckInComponent } from './components/dashboard-check-in/dashboard-check-in.component';
import { QrAssignPuesComponent } from './components/qr-management/qr-assign-pues/qr-assign-pues.component';
import { QrModeComponent } from './components/qr-mode/qr-mode.component';
import { ImageSlideFormlyType } from './components/image-slide-formly-components';
import { HazidTabOneFormlyType } from './components/hazid-tab-one-formly-components';
import { HazidTypeFormlyType } from './components/hazid-type-formly-components';
import { CheckinPopupComponent } from './components/checkin-popup/checkin-popup.component';
import { RapidObervationsListComponent } from './components/rapid-component/rapid-obervations-list/rapid-obervations-list.component';
import { RatingListComponent } from './components/rating-list/rating-list.component';
import { RatingInfoComponent } from './components/rating-info/rating-info.component';
import { RatingFilterSortingComponent } from './components/rating-filter-sorting/rating-filter-sorting.component';
import { SiteRatingComponent } from './components/site-rating/site-rating.component';
import { HouseAndRatingImagesComponent } from './components/house-and-rating-images/house-and-rating-images.component';
import { DeleteQrComponent } from './components/delete-qr/delete-qr.component';
// import { OrdinalPipe } from 'src/app/pipes/ordinalPipe';

import { ImageSliderComponent } from './components/my-observation-component/image-slider/image-slider.component';
import { CvpcRadioButtonFormlyType } from './components/cvpc-radiobutton-formly-component';
import { QuestionaireRadioButtonFormlyType } from './components/questionaire-radiobutton-formly-component';
import { FullScreenImageComponent } from './components/full-screen-image/full-screen-image.component';
import { CustomFormlyCardType } from './components/custom-formly-card-formly-components';
import { CvpcRelatestoFormlyType } from './components/cvpc-relatesto-formly-component';
import { CvpcPersonObservedFormlyType } from './components/cvpc-person-observed-formly-component';
import { MorePage } from './pages/more/more.page';
import { QrCodeScannerPage } from './pages/qr-code-scanner/qr-code-scanner.page';
import { AssignedToModalPage } from './pages/assigned-to-modal/assigned-to-modal.page';
import { PolicyAndTermsPage } from './components/policy-and-terms/policy-and-terms.page';
import { UserConfigurationComponent } from './components/workgroup_management/user-configuration/user-configuration.component';
import { PopoverComponent } from './components/popover/popover.component';
import { NotificationListComponent } from './components/notification-list/notification-list.component';
import { VpcHazService } from './pages/vpc-haz/vpc-haz.service';
import { AddActionPage } from './pages/add-action/add-action/add-action.page';
import { ControllerOptionsComponent } from './components/controller-options/controller-options.component';
import { KeyLessonPuesVideosPage } from './pages/qr-management-update/key-lesson-pues-videos/key-lesson-pues-videos.page';
// import { AppHeaderComponent } from './components/app-header/app-header.component';
import { SharedModule } from './share.module';
import { ActionClosedComponent } from './components/action-closed-popup/action-closed.component';
import { ViewTeamPage } from './pages/treasure_hunt/view-team/view-team.page';
import { ChallengePopupComponent } from './components/treasure-hunt/challenge-popup/challenge-popup.component';
import { AcceptHuntComponent } from './components/accept-hunt/accept-hunt.component';
import { LocationErrorComponent } from './components/location-error/location-error.component';
import { RapidDraftPage } from './pages/rapid-tour/rapid-draft/rapid-draft.page';
import { GadEmployeeComponent } from './components/rapid-component/gad-employee/gad-employee.component';
import { AsseessmentMailComponent } from './components/rapid-component/asseessment-mail/asseessment-mail.component';
import { PopupModelComponent } from './components/checkin/maps/popup-model/popup-model.component';
// import { TabViewComponent } from './components/checkin/maps/tab-view/tab-view.component';
import { ImgSlideViewComponent } from './components/checkin/maps/img-slide-view/img-slide-view.component';
import { OverviewComponent } from './components/checkin/overview/overview.component';
import { HkComponent } from './components/checkin/hk/hk.component';
import { ShieldComponent } from './components/checkin/shield/shield.component';
import { ShieldFooterComponent } from './components/shield-footer/shield-footer.component';
import { NonShieldFooterComponent } from './components/non-shield-footer/non-shield-footer.component';
import { RewardsAndRecognitionComponent } from './components/checkin/rewards-and-recognition/rewards-and-recognition.component';
import { CreComponent } from './components/checkin/cre/cre.component';
import { FilterComponent } from './components/checkin/filter/filter.component';
import { AreaOwnerInfoComponent } from './components/bog_tour/area-owner-info/area-owner-info.component';
import { CustomRelatesToFormlyType } from './components/relates-to-formly.component';
import { TabComponent } from './components/relates-tab.component';
import { TabsComponent } from './components/relates-tab-group.components';
import { vpcHazRiskSliderFormlyType } from './components/risk-level-component';
import { IDiscussedFormlyType } from './components/i-discussed-search';
import { AddContractorComponent } from './components/bog_tour/add-contractor/add-contractor.component';
import { TeamCreationSuccess } from './components/treasure-hunt/team-creation-success/team-creation-success';
import { AvatarSelectionComponent } from './components/treasure-hunt/avatar-selection/avatar-selection.component';
import { SponsorsListComponent } from './components/treasure-hunt-leagues/sponsors-list/sponsors-list.component';
import { FilterLeaguesComponent } from './components/leagues/filter-leagues/filter-leagues.component';
import { LeagueInfoPopupsComponent } from './components/leagues/league-info-popups/league-info-popups.component';
import { CoinFallPopupAnimationComponent } from './components/treasure-hunt/coin-fall-popup-animation/coin-fall-popup-animation.component';
import { THBannerBubbleComponent } from './components/treasure-hunt/thbanner-bubble/thbanner-bubble.component';
import { RulesPopupComponent } from './components/leagues/rules-popup/rules-popup.component';
import { ThGRUUserSearchComponentComponent } from './components/treasure-hunt/team-registration-flow/th-gruuser-search-component/th-gruuser-search-component.component';
import { INominateFormlyType } from './components/i-nominate-search';
import { BravoGoodPracticesFormlyType } from './components/bravo-good-practice-search';
import { ActionListComponent } from './components/action-list/action-list.component';
import { BogProComponent } from './components/checkin/bog-pro/bog-pro.component';
import { CheckinPerformanceComponent } from './components/checkin/checkin-performance/checkin-performance.component';
import { ShieldCustomCardType } from './components/shield-custom-card-formly-components';
import { RelatesToSelectionComponent } from './components/relates-tab-select.components';
import { RapidLandingScreenPage } from './pages/rapid-tour/rapid-landing-screen/rapid-landing-screen.page';
import { JwtInterceptor } from './services/http-service/jwt-interceptor.service';
import { IDiscussedUserListComponent } from './components/rapid-component/i-discussed-user-list/i-discussed-user-list.component';
import { TenantService } from './services/tenant/tenant.service';
import { ThAddActionForFindingComponent } from './components/treasure-hunt/th-add-action-for-finding/th-add-action-for-finding.component';
import { AddUserForActionPage } from './components/treasure-hunt/th-add-action-for-finding/add-user-for-action/add-user-for-action.page';
import { assignedToAddAction } from './components/add-action-assigned-to';
import { VpcHazIsHighRiskOrStopWorkFormlyType } from './components/immediate-risk-type-selection';
import { SearchUsersComponent } from './components/search-users/search-users.component';
import { SeparateInputType } from './components/treasure-hunt/formly-custom-inputs/separate-input.type';
import { SeparateSelectType } from './components/treasure-hunt/formly-custom-inputs/separate-select.type';
import { NoiseLevelTypeComponent } from './components/treasure-hunt/formly-custom-inputs/noise-level.type';

// import { provideAnalytics, getAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
// import { provideRemoteConfig, getRemoteConfig, SETTINGS, DEFAULTS } from '@angular/fire/remote-config';
// import { CONFIG, DEBUG_MODE } from '@angular/fire/analytics';
// import { REGION } from '@angular/fire/functions';
// import { APP_VERSION, APP_NAME } from '@angular/fire/app';

// import { FirebaseCrashlytics } from '@ionic-native/firebase-crashlytics/ngx';
// import {ActionManagementNonHseComponent} from './components/action-management-non-hse/action-management-non-hse.component'
// import { ActionManagementHseComponent } from './components/action-management-hse/action-management-hse.component';
const materialModules = [
  MatNativeDateModule,
  MatInputModule,
  MatAutocompleteModule,
  MatSlideToggleModule,
  MatListModule,
  MatRippleModule,
  MatSliderModule,
];

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    AutocompleteFormlyComponent,
    MultiCheckboxFormlyType,
    CheckboxRepeat,
    CustomAccordianFormlyType,
    CustomRelatesToFormlyType,
    ImageSlideFormlyType,
    HazidTabOneFormlyType,
    HazidTypeFormlyType,
    CustomFormlyCardType,
    ShieldCustomCardType,
    CustomToggleFormlyType,
    CustomRadioButtonFormlyType,
    RadioButtonFormlyType,
    assignedToAddAction,
    BonusRadioButtonFormlyType,
    TreasureHuntInfoComponent,
    AddContractorComponent,
    CvpcRelatestoFormlyType,
    vpcHazRiskSliderFormlyType,
    VpcHazIsHighRiskOrStopWorkFormlyType,
    IDiscussedFormlyType,
    INominateFormlyType,
    BravoGoodPracticesFormlyType,
    CvpcPersonObservedFormlyType,
    CvpcRadioButtonFormlyType,
    TreasureHuntChangeDateComponent,
    FilterLeaguesComponent,
    LeagueInfoPopupsComponent,
    RulesPopupComponent,
    DashboardCheckInComponent,
    ReassignActionComponent,
    FilterActionStatusComponent,
    AddOrRemoveZonesComponent,
    AddOrRemoveZonesComponent,
    SponsorsListComponent,
    AcceptHuntComponent,
    RatingListComponent,
    RatingInfoComponent,
    RatingFilterSortingComponent,
    SiteRatingComponent,
    QrAssignPuesComponent,
    QrModeComponent,
    QrCodeScannerPage,
    DeleteQrComponent,
    RapidObervationsListComponent,
    CheckinPopupComponent,
    HouseAndRatingImagesComponent,
    FullScreenImageComponent,
    ImageSliderComponent,

    MorePage,
    AssignedToModalPage,
    PolicyAndTermsPage,
    AddActionPage,
    RapidLandingScreenPage,
    TeamCreationSuccess,
    UserConfigurationComponent,
    PopoverComponent,
    NotificationListComponent,
    GRUEditComponent,
    PolicyAndTermsPage,
    THBannerBubbleComponent,
    ControllerOptionsComponent,
    KeyLessonPuesVideosPage,
    //RapidDraftPage,
    ActionClosedComponent,
    ThGRUUserSearchComponentComponent,
    ViewTeamPage,
    ChallengePopupComponent,
    LocationErrorComponent,
    GadEmployeeComponent,
    AsseessmentMailComponent,
    PopupModelComponent,
    // TabViewComponent,
    ImgSlideViewComponent,
    OverviewComponent,
    CheckinPerformanceComponent,
    HkComponent,
    ShieldComponent,
    RewardsAndRecognitionComponent,
    CreComponent,
    BogProComponent,
    FilterComponent,
    AreaOwnerInfoComponent,
    TabComponent,
    TabsComponent,
    RelatesToSelectionComponent,
    AvatarSelectionComponent,
    CoinFallPopupAnimationComponent,
    ActionListComponent,
    IDiscussedUserListComponent,
    SearchUsersComponent,
    ThAddActionForFindingComponent,
    AddUserForActionPage,
    // ActionManagementNonHseComponent,
    // ActionManagementHseComponent,
    ShieldFooterComponent,
    NonShieldFooterComponent
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  imports: [
    MentionModule,
    MatDialogModule,
    MatTabsModule,
    BrowserModule,
    IonicModule.forRoot({
      innerHTMLTemplatesEnabled: true,
      mode: 'ios'
    }),
    FormsModule,
    ReactiveFormsModule,
    RoundProgressModule,
    NgApexchartsModule,
    DragDropModule,
    SharedModule,
    CommonModule,
    NgxIntlTelInputModule,
    MatSliderModule,
    TextareaWithCounterComponent,
    QuestionaireRadioButtonFormlyType,
    FormlyModule.forRoot({
      wrappers: [
        { name: 'custom-accordian-wrapper', component: CustomAccordianFormlyType },
        { name: 'custom-image-slide', component: ImageSlideFormlyType },
        { name: 'haz-type-select', component: HazidTypeFormlyType },
        { name: 'custom-hazid-tab-one', component: HazidTabOneFormlyType },
        { name: 'custom-formly-card', component: CustomFormlyCardType },
        { name: 'shield-custom-card', component: ShieldCustomCardType },
      ],
      types: [
        {
          name: 'autocomplete',
          component: AutocompleteFormlyComponent,
          wrappers: ['form-field'],
        },
        { name: 'custom-multicheckbox', component: MultiCheckboxFormlyType },
        { name: 'custom-radiobutton', component: RadioButtonFormlyType },
        { name: 'new-custom-radiobutton', component: CustomRadioButtonFormlyType },
        { name: 'custom-bonus-radiobutton', component: BonusRadioButtonFormlyType },
        { name: 'unwanted-cvpcbutton', component: CvpcRadioButtonFormlyType },
        { name: 'custom-toggle', component: CustomToggleFormlyType },
        { name: 'custom-repeater', component: CheckboxRepeat },
        { name: 'cvpc-relatesto-radiobutton', component: CvpcRelatestoFormlyType },
        { name: 'vpc-haz-risk-level', component: vpcHazRiskSliderFormlyType },
        { name: 'i-discussed-user', component: IDiscussedFormlyType },
        { name: 'relatesto-personobserved', component: CvpcPersonObservedFormlyType },
        { name: 'questionaire-radiobutton', component: QuestionaireRadioButtonFormlyType },
        { name: 'custom-relates-to', component: CustomRelatesToFormlyType },
        { name: 'i-nominate-user', component: INominateFormlyType },
        { name: 'bravo-good-practice', component: BravoGoodPracticesFormlyType },
        { name: "assigned-to-add-action", component: assignedToAddAction },
        {
          name: "vpc-haz-isHighRiskOrStopWork",
          component: VpcHazIsHighRiskOrStopWorkFormlyType,
        },
        {
          name: "textarea-with-counter",
          component: TextareaWithCounterComponent,
        },
            { name: 'separate-input', component: SeparateInputType },
            { name: 'separate-select', component: SeparateSelectType },
            { name: 'noise-level-type', component: NoiseLevelTypeComponent }


      ],
      validators: [
        {
          name: "maxWords",
          validation: maxWordsValidator(250),
        },
        { name: 'noWhitespace', validation: (control) => {
        if (!control.value) return null;
        const isWhitespace = (control.value || '').trim().length === 0;
        return !isWhitespace ? null : { 'whitespace': true };
      }}
      ],
      validationMessages: [
        { name: 'whitespace', message: 'Field cannot contain only spaces' },
        { name: 'required', message: 'This field is required' }
      ],
      extras: { lazyRender: true },
    }),
    LoggerModule.forRoot({
      level: NgxLoggerLevel.DEBUG,
      colorScheme: ['purple', 'teal', 'green', 'gray', 'red', 'red', 'red'],
    }),
    IonicStorageModule.forRoot(),
    AppRoutingModule,
    GeolocationModule,
    BrowserAnimationsModule,
    FormlyMaterialModule,
    FormlyMatDatepickerModule,
    MatFormFieldModule,
    MatDatepickerModule,
    FormlyMatToggleModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ConnectionServiceModule,
    ...materialModules,
    ScrollingModule,
    PickerModule,
    NgxSliderModule,
  ],
  providers: [
    BackgroundMode,
    {
      provide: ROUND_PROGRESS_DEFAULTS,
      useValue: {
        color: '#f00',
        background: '#0f0',
      },
    },
    SearchService,
    ScreenTrackingService,
    VpcHazService,
    // Network,
    // FirebaseCrashlytics,
    UserTrackingService,
    NgxImageCompressService,
    { provide: HAMMER_GESTURE_CONFIG, useClass: IonicGestureConfig },
    {
      provide: FORMLY_CONFIG,
      multi: true,
      useFactory: registerTranslateExtension,
      deps: [TranslateService],
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: ConnectionServiceOptionsToken,
      useValue: <ConnectionServiceOptions>{
        enableHeartbeat: true,
        requestMethod: 'get',
        heartbeatInterval: 60000 * 2, // 2 minutes
        heartbeatRetryInterval: 10000,
        heartbeatUrl: environment.ping_url,
      },
    },
    // {
    //   provide: ErrorHandler,
    //   useValue: Sentry.createErrorHandler({
    //     showDialog: true,
    //   }),
    // },
    // {
    //   provide: Sentry.TraceService,
    //   deps: [Router],
    // },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: () => () => { },
    //   deps: [Sentry.TraceService],
    //   multi: true,
    // },
    // {
    //   provide: USE_AUTH_EMULATOR,
    //   useValue: !environment.production ? ['localhost', 9099] : undefined
    // },
    // {
    //   provide: USE_FUNCTIONS_EMULATOR,
    //   useValue: !environment.production ? ['localhost', 5002] : undefined
    // },
    // {
    //   provide: USE_FIRESTORE_EMULATOR,
    //   useValue:  !environment.production ? ['localhost', 8080] : undefined
    // }
    DatePipe,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    // { provide: MdDialogRef, useValue: {} }, --> deprecated
    { provide: MatDialogRef, useValue: {} },
    DecimalPipe,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideFirebaseApp(() => initializeApp(FIREBASE_CONFIG)),

    provideAuth(() => {
      const app = inject(FirebaseApp);
      return initializeAuth(app, {
        persistence: browserLocalPersistence,
      });
    }),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    provideFunctions(() => getFunctions()),
    provideAnalytics(() => getAnalytics()),
    provideRemoteConfig(() => getRemoteConfig()),
    provideDatabase(() => getDatabase()),

  ],
})
export class AppModule {
  constructor(injector: Injector) {
    AppInjectorService.injector = injector;
  }
}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
export function maxWordsValidator(maxWords: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || "";
    const wordCount = value
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0).length;
    return wordCount > maxWords
      ? { maxWords: { actual: wordCount, max: maxWords } }
      : null;
  };
}